import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5121/api/v1';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor: Attach Token
apiClient.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('admin_token');

    // Attach token if present and not skipping auth
    if (token && !(config as any).skipAuth) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error: AxiosError) => {
    const originalRequest = error.config as InternalAxiosRequestConfig & { _retry?: boolean };

    // Handle 401 Unauthorized
    if (error.response?.status === 401 && !originalRequest._retry) {
      const publicPaths = ['/login', '/forgot-password', '/reset-password', '/verify'];
      const isPublicPage = publicPaths.some(p => window.location.pathname.startsWith(p));

      if (!isPublicPage) {
        console.warn('[API Client] 401 Unauthorized detected - Session expired. Logging out...');

        // Clear local token
        localStorage.removeItem('admin_token');

        // Trigger Keycloak logout if available, otherwise fallback to /login redirect
        const kc = (window as any).keycloak;
        if (kc) {
          kc.logout();
        } else {
          window.location.href = '/login';
        }
      }

      return Promise.reject(error);
    }

    // Handle 403 Forbidden
    if (error.response?.status === 403) {
      console.warn('[API Client] 403 Forbidden detected - Insufficient permissions.');
      const message = "you dont have enough permission to view";
      if (error.response.data && typeof error.response.data === 'object') {
        (error.response.data as any).message = message;
      } else {
        error.response.data = { message };
      }
    }

    // Handle other errors
    if (error.response) {
      console.error('[API Client] ❌ API Response Error:', {
        status: error.response.status,
        url: error.config?.url,
        data: error.response.data,
      });
    } else {
      console.error('[API Client] ⚠️ Network/Unknown Error:', error.message);
    }

    return Promise.reject(error);
  }
);

export default apiClient;